export const locale = {
  lang: 'es',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'FOCUS':{
      'GRUPOS':{
        'ADMIN': 'Administrador de grupos',
        'CREAR': 'Crear grupo',
        'EDITAR': 'Editar Grupo',
        'APLICAR': 'Aplicar',
        'NAME':'Nombre del grupo',
        'DESCRIPCION': 'Descripción',
        'FILTROS': 'Filtros',
        'ACCION': 'Acciones',
        'EDIT': 'Editar',
        'DELETE': 'Eliminar'
      },
      'CREAR': {
        'DATO': 'Datos del grupo',
        'NAME': 'Nombre del grupo',
        'DESCRIPCION': 'Descripción del grupo',
        'FILTROS': 'Filtros',
        'FILSELEC': 'Filtros seleccionados',
        'COUNTRY': 'País',
        'CARGO': 'Cargo y/o función',
        'ANTIG': 'Antiguedad',
        'GENDER': 'Género'
      },
      'REACTIVOS': {
        'SIN': 'Aún no ha realizado la selección de reactivos',
        'STEPS': {
          '1': {
              'TITULO': 'Selección de reactivos',
              'DISPONIBLES': 'Plantillas disponibles:',
              'LISTADO': {
                'TITULO': 'Construya la lista de reactivos que desee visualizar en la encuesta',
                'SUBTITULO': 'Elija una plantilla de la lista para mostrar su listado de reactivos',
                'PICKEDTITU': 'Lista de reactivos de la plantilla: ',
                'PICKEDTOT': 'Reactivos disponibles: ',
                'PICKEDNUM': 'Reactivos seleccionados: ',
              }
          },
          '2': {
              'TITULO': 'Traducciones'
          },
          '3': {
              'TITULO': 'Previsualización',
              'TEXTOS': {
                'es': {
                  'EMPRESA': 'Responde pensando en tu empresa y en todos los líderes',
                  'AREA': 'Responde pensando en tu área de trabajo y tu líder directo',
                  'BOTONES': {
                    '0': 'Casi siempre es falso',
                    '1': 'Frecuentemente es falso',
                    '2': 'A veces es falso / A veces es verdad',
                    '3': 'Frecuentemente es verdad',
                    '4': 'Casi siempre es verdad'
                  }
                },
                'en': {
                  'EMPRESA': 'Organization Perspective',
                  'AREA': 'Workgroup Perspective',
                  'BOTONES': {
                    '0': 'It is almost always false',
                    '1': 'It is often false',
                    '2': 'Sometimes it´s fake / Sometimes it´s true',
                    '3': 'It is often true',
                    '4': 'It is almost always true'
                  }
                },
                'pt': {
                  'EMPRESA': 'Perspectiva da organização',
                  'AREA': 'Perspectiva do grupo de trabalho',
                  'BOTONES': {
                    '0': 'Quase sempre é falso',
                    '1': 'É frequentemente falso',
                    '2': 'Às vezes é falso / às vezes é verdade',
                    '3': 'É frequentemente verdade',
                    '4': 'Quase sempre é verdade'
                  }
                },
              }
            }
          }
        }
    },
    'CERTIFICAR': {
      'IDIOMAS': {
        'ELEGIR': 'Elegir',
        'STATUS': {
          'PEND': 'Completar paso',
          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'MENSAJES':{
          'ADDLANG': 'Se añadió el idioma ',
          'NOADITIONAL': 'Se eligió la opción sin idiomas adicionales',
          'ERRORADD': 'Ocurrió un error al añadir el idioma',
          'LANGDEL': 'Se eliminó el idioma ',
          'NOADITIONALDEL': 'Se canceló la selección sin idiomas adicionales',
          'ERRORDEL': 'Ocurrió un error al eliminar el idioma',
          'MAINPICKED': 'Ya ha elegido el idioma nativo para la encuesta.<br><br> Para cambiarlo, quite el idioma seleccionado y elija el nuevo idioma'
        },
        'CARD1': {
          'TITULO': 'Idioma principal',
          'ACCION': {
            'PRE': 'No ha seleccionado el idioma principal',
            'POST': 'Ha seleccionado el idioma: '
          },
          'MODAL': {
            'TITULO': 'Elija el idioma principal',
            'ACCION': '¿Cuál es el idioma principal de la encuesta?',
            'PLACELISTA': 'Seleccione un idioma',
            'BOTONES': {
              'BACK': 'Regresar',
              'OK': 'Listo'
            }
          }
        },
        'CARD2': {
          'TITULO': 'Idiomas adicionales',
          'ACCION': {
            'PRE': 'No ha seleccionado idiomas adicionales',
            'SINADIC': 'La encuesta no tendrá idiomas adicionales',
            'POST': 'Ha seleccionado los idiomas: '
          },
          'MODAL': {
            'TITULO': 'Elija los idiomas adicionales',
            'ACCION': '¿Qué idiomas adicionales desea agregar a la encuesta?',
            'BOTONES': {
              'BACK': 'Regresar',
              'OK': 'Listo'
            }
          }
        }
      },
      'NPS': {
        'CONFIGURE_QUESTION': 'Presione aquí para visualizar el NPS',
        'ADD': 'Crear una pregunta:',
        'QUESTIONUPDATEDOK': 'NPS actualizado con éxito',
        'STATUS': {
          'PEND': 'Completar paso',

          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'TABS': {
          'TAB1': 'NPS',
          'TAB2': 'Traducción',
          'TAB3': 'Previsualización',
        }
      },

      'REACTIVOS': {
        'CONFIGURE_QUESTION': 'Presione aquí para visualizar el reactivo',
        'ADD': 'Crear una pregunta:',
        'QUESTIONUPDATEDOK': 'Reactivo actualizado con éxito',
        'STATUS': {
          'PEND': 'Completar paso',

          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'TABS': {
          'TAB1': 'Reactivos',
          'TAB2': 'Traducción',
          'TAB3': 'Previsualización',
        }
      },
      'CONTROL': {
        'CONFIGURE_QUESTION': 'Presione aquí para visualizar la pregunta de control',
        'ADD': 'Crear una pregunta:',
        'QUESTIONUPDATEDOK': 'Pregunta de control actualizada con éxito',
        'STATUS': {
          'PEND': 'Completar paso',

          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'TABS': {
          'TAB1': 'Pregunta de control',
          'TAB2': 'Traducción',
          'TAB3': 'Previsualización',
        }
      },
      'DEMOGRAFICOS': {
        'NOINFO':'No hay información disponible',
        'TAB1': 'Demográficos',
        'TAB2': 'Traducción',
        'TAB3': 'Previsualización',
        'COMPLETAR_PASO': 'Completar paso',
        'PASO_COMPLETADO': 'Paso completado',
        'SELECT': 'Seleccione una opción',
        'BTN_DEMOGRAFICOS': 'Aceptar',
        'OPTION_SURVEY': 'Encuesta',
        'OPTION_EXCEL': 'Excel',
        'OPTION_AMBOS': 'Ambos',
        'CLAVE': 'Clave',
        'RESPONSE_NOT_ADDED': 'No se pueden agregar respuestas a una pregunta abierta',
        'CONFIGURE_QUESTION': 'Presione aquí para visualizar la pregunta',
        'QUESTION': 'Pregunta',
        'OPCIONES_RESPUESTA': 'Opciones de respuesta',
        'STATUS': {
          'PEND': 'Completar paso',
          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'EXPANSION':{
          'Work Responsability' : 'Responsabilidad del trabajo',
          'Trust Level' : 'Nivel de confianza',
          'Innovation' : 'Innovación',
          'Disabilities' : 'Discapacidades',
          'Ethnic Group' : 'Grupo étnico',
          'Personal Responsabilities' : 'Responsabilidades personales',
          'Gender' : 'Género',
          'Work Location' : 'Lugar de trabajo',
          'Travel' : 'Viaje',
          'Living Location' : 'Lugar de residencia',
          'Marital Status' : 'Estado civil',
          'Home Type' : 'Tipo de hogar',
          'Home Location' : 'Ubicacion de la casa',
          'Home Status' : 'Estado del hogar',
          'Transport' : 'Transporte',
          'Sports' : 'Deportes',
          'Weight' : 'Peso',
          'Sleep' : 'Dormir',
          'Home Office' : 'Trabajo en casa',
          'Languages' : 'Languajes',
          'Work Experience' : 'Experiencia de trabajo',
          'Social Networks' : 'Redes sociales',
          'Employ Opportunities' : 'Oportunidades de empleo',
          'Inspiration' : 'Inspiración',
          'Meetings' : 'Reuniones',
          'Tenure' : 'Tenencia',
          'Clave': 'Clave',
          'Ege': 'Generación',
          'Work Status': 'Estado del trabajo',
          'Education': 'Educación',
          'Hierarchical Level': 'Nivel Jerárquico',
          'Confidence Decisions': 'Decisiones de confianza',
          'Work Innovation': 'Innovación en el trabajo',
          'Belong': 'Pertenecer',
          'Converse Performance': 'Frecuencia de reuniones',
          'Work Years':'Años de trabajo',
          'Generation':'Generación',
          'Confidence In Decisions': 'Confianza en las decisiones',
          'Develop New Things': 'Desarrollar cosas nuevas',
          'Reason To Stay':'Razón para quedarse',
          'Age':'Edad',
          'Type Of Job':'Tipo de trabajo',
          'Minoritate':'Minorita',
          'Sindicat':'Sindicato',
          //TURQUIA//
          'Confidence':'Confianza',
          'Opportunities':'Oportunidades',
          'Managerial Level':'Nivel gerencial',
          'Years Of Service':'Años de servicio',
          'Ethnic':'Étnico',
          //CAYC//
          'Hierarchical Leve':'Nivel jerárquico',
          'Disability':'Discapacidad',
          'Responsibility':'Responsabilidad',
          'LGBT':'LGBT',

          //BRASIL
          'Permanência':'Permanencia',
          'Reuniões':'Reuniones',
          'Motivo para ficar':'Razón para quedarse',
          'Casa':'Casa',
          'Nível de confiança':'Nivel de confianza',
          'Oportunidades':'Oportunidades',

          //ESPAÑA
          'Recommendation':'Recomendación',
          'Seniority':'Antigüedad',
          'Contracting modality':'Modalidad de contrato',
          'Working':'Trabajo',



          //GCTI
          'Pregunta 1': 'Pregunta 1',
          'Pregunta 2': 'Pregunta 2',
          'Pregunta 3': 'Pregunta 3',
          'Pregunta 4': 'Pregunta 4',
          'Pregunta 5': 'Pregunta 5',
          'Pregunta 6': 'Pregunta 6',
          'Pregunta 7': 'Pregunta 7',
          'Pregunta 8': 'Pregunta 8',
          'Pregunta 9': 'Pregunta 9',
          'Pregunta 10': 'Pregunta 10',
          'Pregunta 11': 'Pregunta 11',
          'Pregunta 12': 'Pregunta 12',
          'Pregunta 13': 'Pregunta 13',
          'Pregunta 14': 'Pregunta 14',
          'Pregunta 15': 'Pregunta 15',
        }
      },
      'FORALL':  {
        'MSJ_PRACTICEREGISTERED':  'Práctica guardada con éxito',
        'MSJ_DESCRIPTIONREGISTERED': 'Descripción guardada con éxito',
        'MSJ_TRANSLATEREGISTERED': 'Práctica traducida con éxito',
        'MSJ_DESCRIPTIONTRANSLATED': 'Descripción traducida correctamente',
        'QUESTIONUPDATEDOK': 'Pregunta actualizada con éxito',
        'QUESTIONUPDATEDFAIL': 'Error, inserte una pregunta válida',
        'RESPONSEUPDATEDOK': 'Respuesta actualizada con éxito',
        'RESPONSEUPDATEDFAIL': 'Error, inserte un texto de respuesta válido',
        'TRANSLATEDOK': 'Pregunta traducida y guardada con éxito',
        'INSERTTRANSLATE': 'Por favor, inserte la traducción',
        'OPTIONTRANSLATED': 'Opción de traducción guardada con éxito',
        'INSERTOPTIONTRANSLATE': 'Por favor, inserte la traducción',
        'MJS_SELECTOPTION': 'Por favor, seleccione una opción',
        'MJS_OPTIONADDED': 'Demografía agregada correctamente',
        'OPTIONDELETED': 'Demografía eliminada con éxito',
        'RESPONSEOPTIONDELETED': 'Respuesta eliminada con éxito',
        'DEMOGRAPHICEXIST': 'La demografía seleccionada ya existe',
        'AGREGADEMOGRAFICO': 'Seleccione para agregar más datos demográficos',
        'MSJ_PRACTICEREQUIRED': 'Práctica requerida!',
        'MSJ_DESCRIPTIONREQUIRED': 'Descripción requerida!',
        'CARGANDO_PRACTICA': 'Guardando práctica, por favor espere...',
        'CARGANDO_DESCRIPCION': 'Guardando descripción, por favor espere...',
        'ACTUALIZAR_OPCION': 'Actualizando respuesta, por favor espere...',
        'REVISANDO_PRACTICAS': 'Revisando prácticas, por favor espere...',


        'SELECCIONE': 'Seleccione un idioma para hacer una vista previa',
        'IDIOMAS_NOT_SELECTED': 'No se seleccionaron idiomas adicionales',
        'TRANSLATE_NOT': 'Necesita redactar al menos el nombre de una práctica y su descripción',
        'PLACEHOLDER': 'Idioma',
        'DESC_TRANSLATE': 'Ingrese la traducción de la práctica',
        'DESC_TRANSLATE_DEMO': 'Ingrese la traducción de la respuesta',
        'DESC_TRANSLATE_FORALL': 'Ingrese la traducción  de la descripcion',
        'PRACTICE_TRANSLATE_REACTIVOS': 'Ingrese la traducción del reactivo',
        'PRACTICE_TRANSLATE_ABIERTAS': 'Ingrese la traducción de la pregunta abierta',
        'PRACTICE_TRANSLATE_FORALL': 'Ingrese la traducción de la práctica',
        'PRACTICE_TRANSLATE_DEMO': 'Ingrese la traducción del demografico',



        'IDIOMAS': {
          'Native': 'Nativo',
          'es': 'Español',
          'zh1': 'Chino tradicional',
          'zh2': 'Chino simplificado',
          'pt': 'Portugués',
          'en': 'Inglés',
          'vi': 'Vietnamita'
        },
        'RESPUESTAS': {
          'Native': 'Nativo',
          'es':{'si': 'Sí',
          'no':'No',
          'casifalso':'Casi siempre es falso',
          'false': 'Frecuentemente es falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Frecuentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'zh1':{'si': '有','no':'沒有',
          'casifalso':'從來不是這樣',
          'false': '經常不是這樣',
          'avecesfalse': '有時是有時不是',
          'casiverdad': '經常是這樣',
          'verdad': '總是這樣'},
          'zh2':{'si': '有','no':'没有',
          'casifalso':'从来不是这样',
          'false': '经常不是这样',
          'avecesfalse': '有时是有时不是',
          'casiverdad': '经常是这样',
          'verdad': '总是这样'},
          'pt':{'si': 'Si','no':'não',
          'casifalso':'Casi siempre es falso',
          'false': 'Freqüentemente é falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Freqüentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'en':{'si': 'Yes','no':'No',
          'casifalso':'It is almost always false',
          'false': 'It is often false',
          'avecesfalse': 'Sometimes it´s fake / Sometimes it´s true',
          'casiverdad': 'It is often true',
          'verdad': 'It is almost always true'},
          'tr':{'si': 'Evet','no':'HAYIR',
          'casifalso':'Neredeyse her zaman yanlış',
          'false': 'Sık sık yanlış',
          'avecesfalse': 'Bazen doğru olmayan / bazen doğru',
          'casiverdad': 'Genellikle doğru',
          'verdad': 'Neredeyse her zaman doğru'},
          'jp':{'si': 'はい','no':'番号',
          'casifalso':'ほとんど常に当てはまらない',
          'false': 'しばしば当てはまらない',
          'avecesfalse': '時には当てはまらない／時には当てはまる',
          'casiverdad': 'しばしば当てはまる',
          'verdad': 'ほとんど常に当てはまる'},

          'vi':{'si': 'Đúng','no':'Không',
          'casifalso':'Nó gần như luôn luôn là sai',
          'false': 'Nó thường sai',
          'avecesfalse': 'Đôi khi nó là hàng giả / Đôi khi nó đúng',
          'casiverdad': 'Nó thường đúng',
          'verdad': 'Nó gần như luôn luôn đúng'}
        },
        'STATUS': {
          'PEND': 'Completar paso',
          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'TABLA': {
          'TITULOS': {
            'DEFAULT': 'Idioma principal',
            'TRADUCCION': 'Traducciones',
            'PREVIEW': 'Previsualización'
          },
          'ENCABEZADOS': {
            'PRACT': 'Práctica:',
            'DESCR': 'Descripción:',
            'STT1': 'Statement 1:',
            'STT2': 'Statement 2:',
            'LANG': 'Idioma:'
          },
          'INPUTS': {
            'PRACT': 'Introduzca el texto de la práctica',
            'DESCR': 'Introduzca el texto de la descripción'
          }
        }
      },
      'ABIERTAS': {
        'STATUS': {
          'PEND': 'Completar paso',
          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'TABS': {
          'TAB1': 'Preguntas abiertas',
          'TAB2': 'Traducción',
          'TAB3': 'Previsualización',
        }
      },
      'ADICIONALES': {
        'FOCUS':{
          'ENVIO-AUTORIZACION':'Se ha enviado a autorizacion',
          'AUTORIZACION-OK':'Se ha Autorizado su encuesta,Proceda a Completar el paso',

        },
        'STATUS': {
          'PEND': 'Completar paso',
          'DONE': 'Paso completado',

          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },
        'TABS': {
          'QUESTIONS': 'Preguntas adicionales',
          'TRANSLATE': 'Traducciones',
          'PREVIEW': 'Previsualización'
        },
        'PREGUNTAS':{
          'STATUS': {
            'SIN': 'No ha creado preguntas adicionales',
            'CON': 'Preguntas creadas:',
            'NOADICIONALES': 'Se eligió la opción sin preguntas adicionales',
            'CANCELNOADIC': 'Se canceló la opción sin preguntas adicionales',
            'ERROR': 'Ocurrió un error al realizar la operación'
          },
          'ACCIONES': {
            'ADD': 'Crear una pregunta:',
            'SIN': 'No agregar preguntas adicionales a la encuesta'
          },
          'WIZARD': {
            'NEW': 'Nueva pregunta',
            'TIPOTITU': 'Presione aquí para configurar la pregunta adicional',
            'TIPO': {
              'OPEN': 'Pregunta abierta',
              'UNI': 'Pregunta de una opción',
              'MULT': 'Pregunta de opción múltiple',
              'MULTLIKERT3-1': 'Pregunta en escala de likert 3',
              'MULTLIKERT5-1': 'Pregunta en escala de likert 5',
              'MULTLIKERT-MUL': 'Pregunta en escala de likert Multiple',
            },
            'FORM': {
              'TIPO': 'Tipo de pregunta:',
              'TOOLTIP': {
                'REMOVE': 'Remover esta pregunta'
              },
              'MENSAJES': {
                'BORRAR': '¿Desea borrar esta pregunta adicional?',
                'PREG_OK': 'La pregunta se almacenó correctamente',
                'PREG_ERR': 'Ocurrió un error al almacenar la pregunta',
                'PREG_MOD_OK': 'La pregunta se modificó correctamente',
                'PREG_MOD_ERR': 'Ocurrió un error al modificar la pregunta',
                'OPC_OK': 'La opción de respuesta se almacenó correctamente',
                'OPC_ERR': 'Ocurrió un error al almacenar la opción de respuesta',
                'OPC_MOD_OK': 'La opción de respuesta se modificó correctamente',
                'OPC_MOD_ERR': 'Ocurrió un error al modificar la opción de respuesta',
                'PREG_DEL_OK': 'La pregunta se eliminó correctamente',
                'PREG_DEL_ERR': 'Ocurrió un error al eliminar la pregunta',
                'OPC_DEL_OK': 'La opción de respuesta fue eliminada correctamente',
                'OPC_DEL_ERR': 'Ocurrió un error al eliminar la opción de respuesta'
              },
              'BOTONES':{
                'SI': 'Sí',
                'NO': 'No'
              }
            },
            'ABIERTA': {
              'TITULO': 'Nueva pregunta abierta:',
              'ACCION': 'Introduzca el texto de la pregunta:',
              'ERROR': 'No ha introducido el texto de la pregunta'
            },
            'MULTI':{
              'TITULOSING': 'Nueva pregunta de una opción:',
              'TITULOMULT': 'Nueva pregunta de opción múltiple:',
              'TITULOLIKERT3': 'Nueva pregunta en escala de likert: 3',
              'TITULOLIKERT5': 'Nueva pregunta en escala de likert: 5',
              'TITULOLIKERTSIMPLE': 'Nueva simple pregunta en escala de likert',
              'ACCION': 'Introduzca el texto de la pregunta:',
              'ERROR': 'No ha introducido el texto de la pregunta',
              'MENSAJES': {
                'BORRAR': '¿Desea borrar esta opción de respuesta?',
                'SINPREG': 'No puede introducir opciones hasta que introduzca el texto de la pregunta',
                'SINANTE': 'No puede introducir el texto de esta opción hasta que introduzca el texto de la opción anterior',
                'WARN-2-1': 'Solamente puede ingresar 2 opciones de respuesta',
                'WARN-3-1': 'Solamente puede ingresar 3 opciones de respuesta',
                'WARN-5-1': 'Solamente puede ingresar 5 opciones de respuesta',
                'WARN-NO-NUMBER': 'Solamente puede ingresar numeros',
                'ETIQUET-VALOR':'Valor',
              },
              'OPCIONES': {
                'TITU': 'Opciones de respuesta',
                'INPUT': {
                  'TITU': 'Opción de respuesta',
                  'ERROR': 'No ha introducido el texto de la opción de respuesta'
                }
              },
              'TOOLTIP': {
                'ADD': 'Agregar una opción de respuesta:',
                'MOVE': 'Mover opción de respuesta',
                'REMOVE': 'Remover esta opción de respuesta'
              }
            }
          }
        },
        'TRADUCCIONES': {
          'TITULO': 'Seleccione un idioma para introducir los textos de traducción',
          'TITULOALTERNO': 'No seleccionó idiomas adicionales en la sección "Idiomas"',
          'NOTYET': 'Traducción aún no completada',
          'MAIN': 'Idioma principal',
          'INPUT': {
            'NEW': 'Introduzca la traducción del reactivo',
            'ERROR': '¡No ha introducido el texto de traducción!',
            'NEWOPC': 'Introduzca la traducción de la opción de respuesta',
            'ERROROPC': '¡No ha introducido el texto de traducción!'
          },
          'MENSAJES': {
            'PREG_OK': 'El texto de traducción se almacenó correctamente',
            'PREG_ERR': 'Ocurrió un error al almacenar el texto de traducción',
            'PREG_MOD_OK': 'El texto de traducción se actualizó correctamente',
            'PREG_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción',
            'OPC_NOPREG': 'No se puede almacenar el texto de traducción de la opción de respuesta sin que introduzca primero el texto de la pregunta',
            'OPC_OK': 'El texto de traducción se almacenó correctamente',
            'OPC_ERR': 'Ocurrió un error al almacenar el texto de traducción',
            'OPC_MOD_OK': 'El texto de traducción se actualizó correctamente',
            'OPC_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción',
            'TRADUC_PREGUNT':'La traduccion de la pregunta se esta guardando...',
            'TRADUC_MOD_PREGUNT':'La traduccion de la pregunta se esta actualizando...',
            'TRADUC_OPC':'La traduccion de la opción se esta guardando...',
            'TRADUC_MOD_OPC':'La traduccion de la opción se esta actualizando...',
            'VALOR_OK':'El valor de la opción se guardo correctamente',
            'VALOR_MOD_OK':'El valor de la opción se actualizo correctamente',
          },
          'COMPLETE': 'Traducción completa'
        },
        'PREVIEW': {
          'TITULO': 'Seleccione un idioma para mostrar las traducciones de las preguntas adicionales',
          'SINPREV': 'No existen textos traducidos para el idioma seleccionado',
          'LOADING': 'Cargando datos...',
          'INPUT': {
            'RESPABIERTA': 'Escriba su respuesta:',
            'ERRORABIERTA': '¡No ha escrito su respuesta!',
            'ELIGELANG': 'Elija un idioma'
          },
          'HELP': {
            'SINGLE': 'Puede elegir una sóla opción en esta pregunta',
            'MULTI': 'Puede elegir más de una opción en esta pregunta',
            'FALTA': '¡Falta ingresar el texto de traducción!'
          }
        }
      },
      'COLABORADORES': {
        'STATUS': {
          'PEND': 'Completar paso',
          'DONE': 'Paso completado',
          'LOCK':'Reabrir paso',
          'UNLOCK':'Paso en proceso'
        },

        'STATUSBAR': {
          'NOBD': 'No ha cargado la lista de colaboradores',
          'PROCES': 'La lista de colaboradores aún no ha sido almacenada',
          'ERROR': 'Se encontraron errores en el archivo',
          'OK': 'La lista de colaboradores está almacenada correctamente',
        },
        'CARD_BD': {
          'TITULO': 'Información: ',
          'NUMCOLABS': 'Número de colaboradores: ',
          'FECHA': 'Última fecha de carga: ',
          'TITULO_PRE': 'Historial de fechas de carga',
          'TITULO_PRE_2': 'Usuarios',
          'ACCIONES': 'Acciones: ',
          'WANNADO': '¿Qué desea realizar?',
          'BOTONES': {
            'DESCARGA': 'Descargar la lista de colaboradores',
            'ELIMINA': 'Eliminar la lista',
            'VER': 'Ver lista de colaboradores'
          }
        },
        'CARD_NOBD': {
          'TITULO': 'Siga estos pasos para cargar la información de sus colaboradores a CULTURAL GO®',
          'PASOS': {
            '1': 'Descargue la plantilla de la lista de colaboradores',
            '2': 'Llene la plantilla con la información de sus colaboradores en base a las columnas proporcionadas',
            '3': 'Cargue el archivo con la información de sus colaboradores',
          },
          'TOOLTIP': 'Este archivo cuenta con macros de validación de datos',
          'FILE': 'Archivo de plantilla de lista de colaboradores'
        },

        'CARD_NOERR': {
          'TITULO': 'Información',
          'NUMCOLABS': 'Número de colaboradores en el archivo: ',
          'FILENAME': 'Nombre del archivo: ',
          'GUARDAR': '¿Desea almacenar esta información?',
          'BOTONES': {
            'SI': 'Sí',
            'NO': 'No'
          }
        },
        'CARD_ERRFND': {
          'TITULO': 'Información: ',
          'ROWS_OK': 'Número de filas correctas: ',
          'MOREINFO': '* Más abajo se muestra a detalle la lista de errores',
          'ROWS_NOTOK': 'Número de filas con errores: ',
          'GUARDAR': 'La información cargada no puede ser almacenada',
          'DELETE': 'Borrar archivo',
          'FILENAME': 'Nombre del archivo: ',
        },
        'CARD_ERRLIST': {
          'TITULO': {
            '1': 'Filas con errores: ',
            '2': 'Errores totales encontrados: '
          },
          'INFO': {
            'ROW': 'Fila: ',
            'SHOW': 'Presione aquí para ver los errores de esta fila',
            'ERRNUM': 'Número de errores: ',
          },
          'DETALLE': {
            'TIPO': 'Tipo de error: ',
            'DESCR': 'Descripción: ',
            'COLUMNA': 'Columna: ',
            'DATO': 'Dato erróneo: '
          },

          'ERRORES': {
            'alfabetica': 'Invalidez alfabética',
            'alfanumerica': 'Invalidez alfanumérica',
            'numerica': 'Invalidez numérica',
            'email': 'Invalidez de correo electrónico',
            'vacio': 'Celda vacía',
            'columna': 'Columna desconocida',
            'catSurvey': 'Información desconocida',
            'repetido': 'Información repetida',
            'clavenumerica':'Invalidez de clave',
            'sameKey': 'Misma clave de jefe',
            'noCeo': 'No se encontró el CEO',
            'bosskeyNotFnd': 'Clave del jefe no existente',
            'continuidad': 'Continuidad en niveles',
            'nivelRepetido': 'Información repetida',
            'multiceo': 'CEO múltiple',
            'age': 'Año de nacimiento incorrecto',
            'seccionSinUsar': 'Clave de sección especial no empleada',
            'date': 'Invalidez de formato de fecha',
            'listOption': 'Información incorrecta',
            'dateFuture': 'Fecha no permitida',
            'longitud_60': 'Número de caracteres permitidos excedido',
            'minimumAge': 'Edad del colaborador por debajo de la mínima'
          },

          'DESCRIPCION': {
            'alfabetica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z) y los siguientes caracteres especiales: ( ) . , : - ',
            'alfanumerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z), numéricos (0 - 9) y los siguientes caracteres especiales: ( ) . , : - ',
            'numerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres numéricos (0 - 9)',
            'email': 'La información no cuenta con la sintáxis correcta ( correo@dominio.com )',
            'vacio': 'La celda carece de información. Esta columna es obligatoria',
            'columna': 'La columna no pertenece a la plantilla proporcionada por CULTURAL GO®',
            'catSurvey': 'La información de la celda no coincide con alguna de las opciones ingresadas en la sección Demográficos de la plataforma',
            'repetido': 'La celda contiene información repetida en otra celda de la misma columna. No se permiten datos repetidos en esta columna.',
            'sameKey': 'La fila contiene la misma clave en las columnas \'Clave de colaborador\' y \'Clave de jefe directo\', esto no está permitido',
            'noCeo': 'La información del CEO no fue encontrada en el listado de colaboradores, es necesario que sea especificado con la clave de colaborador \'0\' para continuar',
            'bosskeyNotFnd': 'La clave del jefe especificada en esta celda no fue encontrada asociada a algún colaborador de la lista',
            'continuidad': 'Se interrumpió la continuidad de niveles en esta celda, los niveles deben ser contínuos',
            'nivelRepetido': 'Se repitió la información de esta celda con la correspondiente al nivel anterior, esto no está permitido',
            'multiceo': 'Se encontró más de un colaborador indicado como el CEO, sólo se permite tener un colaborador indicado como CEO en el archivo',
            'age': 'El año de nacimiento introducido tiene que conformarse de cuatro dígitos',
            'seccionSinUsar': 'Se encontró al menos una clave de sección especial que no fue empleada en el listado de colaboradores. Todas las claves de secciones especiales requieren ser empleadas por lo menos por un colaborador',
            'date': 'La información introducida no cuenta con el formato correcto de fecha',
            'listOption': 'La información introducida no coincide con alguna de las opciones proporcionadas por la plantilla. Sólo se permite elegir una de las opciones predeterminadas en esta celda',
            'dateFuture': 'La fecha introducida en la celda corresponde a una fecha posterior al día actual. Sólo se permite introducir una fecha previa al día actual',
            'longitud_60': 'La información sobrepasa el número máximo de caracteres permitidos para esta columna (60 caracteres)',
            'minimumAge': 'La edad del colaborador introducida se encuentra por debajo de la mínima, la edad mínima para responder la encuesta es de 15 años'
          }
        },
        'CARD_LOAD': {
          'CARGA': {
            'TITULO': 'Cargando...',
            'INFO': 'Analizando la información del archivo, espere un momento'
          },
          'GUARDA': {
            'TITULO': 'Guardando...',
            'INFO': 'Almacenando la información en el sistema, permanezca en esta pantalla hasta que el proceso finalice'
          },
        },
        'MENSAJES': {
          'GUARDA_1': '¿Confirme que desea almacenar la información de ',
          'GUARDA_2': ' colaboradores?',
          'GUARDADO': 'La lista de colaboradores se almacenó correctamente',
          'GUA_ERR': 'Ocurrió un error al almacenar la información. Intente nuevamente más tarde',
          'NODELETE':'No puede eliminar la base de datos si ya se han enviado los correos a sus colaboradores',
          'DELETE_1': '¿Confirme eliminar la información de ',
          'DELETE_2': ' colaboradores?',
          'DEL_OK_1': 'Se eliminaron correctamente ',
          'DEL_OK_2': ' colaboradores',
          'DEL_ERR': 'Ocurrió un error al eliminar la lista de colaboradores. Intente nuevamente más tarde',
          'DEL_ERR_EMA_SEN': 'No es posible realizar esta acción ya que se han enviado los correos electrónicos',
          'DELFILE': 'La lista cargada se removió correctamente',
          'EXCEL': 'Generando archivo de excel, por favor espere un momento',
          'EXTMAL': 'El archivo seleccionado no tiene la extensión correcta. Sólo se permite la carga del archivo proporcionado por CULTURAL GO®',
          'NOROWS': 'El archivo seleccionado no cuenta con ningún registro',
          'VACIO': 'El archivo seleccionado está vacío o la información no se encuentra en la primer hoja',
          'VERSIONANTERIOR': 'El archivo seleccionado corresponde a una versión anterior de la lista de colaboradores, descargue la versión más reciente, cargue la información de sus colaboradores en ese archivo y vuelva a subir el listado',
          'BROKERINCORRECTO': 'El archivo seleccionado no corresponde a la versión del broker al que pertenece la empresa, descargue nuevamente la plantilla, cargue la información de sus colaboradores en ese archivo y vuelva a subir el listado',
          'BOTONES': {
            'SI': 'Sí',
            'NO': 'No'
          }
        },
        'EXCELINFO': {
          'HOJA': 'Datos de colaboradores',
          'TITULO': 'Lista de colaboradores',
          'AUTOR': 'CULTURAL GO®',
          'ASUNTO': 'Descargado de la plataforma'
        },
        'UPLOAD': 'Presione aquí para buscar la lista de colaboradores',
        'REMOVE': 'Remover de la carga',
        'SEND': 'Enviar a la lista',
        'PROCESO': {
          'STP1': 'Analizando la lista de colaboradores',
          'STP2': 'Guardando la lista de colaboradores'
        },
        'ALERT_COLAB':'Los usuarios séran reflejados en la encuesta una vez que este paso sea marcado como completado',
        'MODAL_ERROR': {
          'TITULO': 'Errores encontrados en el archivo',
          'TOTAL_ERRORES_1': 'Errores encontrados en el archivo',
          'TOTAL_ERRORES_2': 'Se encontraron <b>más de 100</b> errores en el archivo',
          'INFO_1': 'A continuación se muestra a detalle la cantidad y tipo de errores específicos',
          'INFO_2': '<b>NOTA:</b> el proceso sólo puede continuar si el archivo no tiene errores, al cerrar esta ventana el proceso será reiniciado. Realice las correcciones necearias al archivo y vuelva a cargarlo',
          'TABLA_RESUMEN': {
            'TIPO': 'Tipo de error',
            'TOTAL': 'Total de errores',
            'ACCIONES': 'Acciones',
            'MASINFO': 'Más información',
            'VERMAS': 'Ver errores'
          },
          'TABLA_LISTA': {
            'TOTAL_1': 'Errores mostrados',
            'TOTAL_2': 'Errores no mostrados',
            'INFO': 'Los errores no mostrados son de características similares a los mostrados',
            'FILA': 'Fila',
            'COLUMNA': 'Columna',
            'DATO': 'Dato erróneo'
          },
          'BOTONES': {
            'REGRESAR': 'Regresar',
            'CONTINUAR': 'Continuar'
          }
        }
      }
    }
  }
};
